import { render, staticRenderFns } from "./VgForm.vue?vue&type=template&id=bf508d88&scoped=true&"
import script from "./VgForm.vue?vue&type=script&lang=js&"
export * from "./VgForm.vue?vue&type=script&lang=js&"
import style0 from "./VgForm.vue?vue&type=style&index=0&id=bf508d88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf508d88",
  null
  
)

export default component.exports